import axios from 'axios';

export const restClient = axios.create({
  headers: {
    'X-CSRF-Token': document.querySelector('meta[name=csrf-token]').attributes
      .content.value,
  },
});
